import { memo } from 'react'

import { LinksBlock } from './components/linksBlock/LinksBlock'
import { SocialBlock } from './components/socialBlock/SocialBlock'
import { IPartnerAdditionalProps } from './models'

import styles from './PartnerAdditional.module.scss'

export const PartnerAdditional = memo<IPartnerAdditionalProps>((props) => {
  return (
    <div className={styles.container}>
      <SocialBlock {...props} />
      <LinksBlock {...props} />
    </div>
  )
})
